import React from 'react';
import cx from 'clsx';

import BaseAppBar from '~/layouts/BaseAppBar';
import useStickyCartBarStore from '~/store/global/useStickyCartBarStore';
import { changedByFontScale } from '~/utils/fontScale';

type Props = React.PropsWithChildren<
  React.ComponentProps<typeof BaseAppBar> & { className?: string }
>;

const BaseLayout = ({ children, className, ...appBarProps }: Props) => {
  const { isVisible } = useStickyCartBarStore();
  return (
    <section
      className={cx(
        'm-auto flex min-h-full max-w-3xl flex-col bg-gray-000 ios-safe-bottom',
        className,
        isVisible && 'pb-[130px]',
        changedByFontScale() && 'overflow-x-hidden',
      )}
    >
      <BaseAppBar {...appBarProps} />
      <main className="flex flex-auto flex-col">{children}</main>
    </section>
  );
};

export default BaseLayout;
